import {onError} from "apollo-link-error"

export default onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors) {
    // empty for now
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
  }
})
